import { camelizeKeys } from 'humps';
import { normalize } from 'normalizr';
import { Template } from '../../types';
import { getCurrentUnixTimestamp } from '../../utils/date';
import { TemplateSchema } from './schema';

interface Options {
  captureException?: (error: string, data?: any) => void;
}

export const normalizeGraphqlTemplateResponse = (
  data: any,
  {
    captureException = () => {},
  }: Options,
) => {
  const { entities, result } = normalize(camelizeKeys(data.templateReport), TemplateSchema);

  const {
    templateReport,
    templateSystems = {},
    templateSubsystems = {},
    templateInformations,
    catalogSystems = {},
    catalogSubsystems = {},
    catalogInformations = {},
  } = entities;

  if (templateReport === undefined) {
    captureException('Template normalized doesn\'t have every required entities:', {
      source: 'normalizeGraphqlTemplateResponse',
      graphqlResponse: Object.keys(data).join(', '),
      normalizedData: Object.keys(result?.entities || result).join(', '),
    });
    return null;
  }

  const {
    templateSystems: templateSystemIds,
    ...templateData
  } = templateReport[result];

  const templateCatalog = {
    systems: catalogSystems,
    subsystems: catalogSubsystems,
    informations: catalogInformations,
  };

  const template: Template = {
    report: { ...templateData, templateSystemIds },
    systems: Object.assign({}, ...Object.keys(templateSystems).map((systemId) => {
      const {
        catalogSystem: catalogSystemId,
        templateSubsystems: templateSubsystemIds,
        ...system
      } = templateSystems[systemId];
      return { [system.id]: { ...system, templateSubsystemIds } };
    })),
    subsystems: Object.assign({}, ...Object.keys(templateSubsystems).map((subsystemId) => {
      const {
        catalogSubsystem: catalogSubsystemId,
        templateInformations: templateInformationIds,
        ...subsystem
      } = templateSubsystems[subsystemId];
      return ({
        [subsystem.id]: {
          ...subsystem,
          catalogInformationIds: templateInformations && templateInformationIds.map((
            tiId: string,
          ) => templateInformations[tiId].catalogInformationId),
        },
      });
    })),
    lastSync: getCurrentUnixTimestamp(),
  };

  return { template, templateCatalog };
};

export * from './schema';
